import * as React from 'react';
import {FiltersModel} from 'components/Map/VehiclesList/CustomFilterComponents';

interface CustomFilterP {
    value: any;
    onChange: Function;
    isActive: boolean;
    toggleOpen: Function;
}

interface TooltipFilteringFilteringP extends CustomFilterP {
    optionList: Array<any>;
    label: string
}

export class TooltipFiltering extends FiltersModel<TooltipFilteringFilteringP, any> {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: []
        };
    }

    public render() {
        const {isActive, toggleOpen, label} = this.props;
        const hasValue = this.state.selectedValues.length > 0;

        return (
            <div className="customFilter customFilter--carCategory customFilter--fleet customFilterGlobal">
                <div className={`customFilter__icon--wrapper customFilterGlobal__icon--wrapper`}>
                    <div
                        className={`customFilter__icon customFilterGlobal__icon ${hasValue ? ' customFilterGlobal__icon--hasValue ' : ''} ${isActive ? ' customFilterGlobal__icon--active ' : ''} `}
                        onClick={() => toggleOpen()}
                    >
                        {!hasValue ? <img src={`./images/icons/arrow_down2.svg`}/> :
                            <img src={`./images/icons/arrow_down3.svg`}/>}
                    </div>
                </div>
                {isActive && (
                    <div className="customFilter__popup customFilterGlobal__popup">
                        <div className="customFilterGlobal__popupWrapper">
                            <div className="customFilter__name customFilterGlobal__name">{label}</div>
                            <div className="customFilter--carCategory__wrapper--list">
                                {this.props.optionList.map((e, i) => (
                                    <div
                                        key={`${e}-${i}`}
                                        className={`customFilter--carCategory__single--list ${this.state.selectedValues.includes(e.value) ? 'active' : ''}`}
                                        onClick={() => {
                                            const selectedValues = this.manageValues(e.value);
                                            this.props.onChange(selectedValues);
                                        }}
                                    >
                                        <img src={e.img} alt=""/>
                                        <span className={'customFilterGlobal__text'}>{e.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/CustomFilterComponents.tsx